import React from 'react'
import { AuthStaticContent, ChangePasswordForm } from '../../components'
import { RLogo, RLogoLight } from '../../assets/svgIcon/customIcon'

const ChangePassword = () => {
  return (
    <div className='login-page signup-page'>
      <RLogoLight className='r-logo d-lg-block d-none' />
      <RLogo className='r-logo d-lg-none d-block' />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xxl-3 col-xl-4 col-lg-5 col-md-12 p-md-0">
            <AuthStaticContent />
          </div>
          <div className="col-xxl-9 col-xl-8 col-lg-7 col-md-12">
            <div className='login-page-form'>
              <ChangePasswordForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChangePassword